import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Content, Text, ToggleButton } from '@leverege/ui-elements'

import { ScriptActions } from '~/actions'
import { SidebarNav } from '~/views' // eslint-disable-line

import style from './style.css'

class ProjectSidebar extends React.Component {

  static propTypes = {
    project : PropTypes.object,
    location : PropTypes.object
  }

  componentDidMount() {
    const { dispatch, project } = this.props
    dispatch( ScriptActions.list( project.id ) )
  }

  render() {
    const { project, scripts, location, history, content } = this.props

    const path = location?.pathname || ''

    return (
      <Content horizontal>

        <Content.Header variant="contentSidebar" className={style.header}>

          <Text variant="navTitle">
            <i className={classnames( 'fa fa-fw fa-layer-group', style.icon )} />
            Device Control
          </Text>

          <ToggleButton
            variant="navItem"
            value={path.startsWith( `/project/${project.id}/blueprint` )}
            title="Blueprints"
            onChange={() => history.push( `/project/${project.id}/blueprint` )}>
            Blueprints
          </ToggleButton>

          <ToggleButton
            variant="navItem"
            value={path.startsWith( `/project/${project.id}/system` )}
            title="Systems"
            onChange={() => history.push( `/project/${project.id}/system` )}>
            Systems
          </ToggleButton>

          <ToggleButton
            variant="navItem"
            value={path.indexOf( '/network' ) >= 0}
            title="Networks"
            onChange={() => history.push( `/project/${project.id}/network` )}>
            Networks
          </ToggleButton>

          <ToggleButton
            variant="navItem"
            value={path.startsWith( `/project/${project.id}/enum` )}
            title="Enums"
            onChange={() => history.push( `/project/${project.id}/enum` )}>
            Enums
          </ToggleButton>

          <ToggleButton
            variant="navItem"
            value={path.startsWith( `/project/${project.id}/resourceEnum` )}
            title="Resource Enums"
            onChange={() => history.push( `/project/${project.id}/resourceEnum` )}>
            Resource Enums
          </ToggleButton>

          <Text variant="navTitle">
            <i className={classnames( 'fa fa-sliders', style.icon )} />
            Flow
          </Text>

          {scripts.items.length > 0 && (
            <ToggleButton
              variant="navItem"
              value={path.indexOf( '/script' ) >= 0}
              title="Scripts"
              onChange={() => history.push( `/project/${project.id}/script` )}>
              Scripts
            </ToggleButton>
          )}

          <ToggleButton
            variant="navItem"
            value={path.indexOf( '/timer' ) >= 0}
            title="Timers"
            onChange={() => history.push( `/project/${project.id}/timer` )}>
            Timers
          </ToggleButton>

          <ToggleButton
            variant="navItem"
            value={path.indexOf( '/messageRoute' ) >= 0}
            title="Message Routes"
            onChange={() => history.push( `/project/${project.id}/messageRoute` )}>
            Message Routes
          </ToggleButton>

          <Text variant="navTitle">
            <i className={classnames( 'fa fa-user', style.icon )} />
            Permissions
          </Text>

          <ToggleButton
            variant="navItem"
            value={path.indexOf( '/authz' ) >= 0}
            title="Roles"
            onChange={() => history.push( `/project/${project.id}/authz/role` )}>
            Roles
          </ToggleButton>

          <ToggleButton
            variant="navItem"
            value={path.indexOf( '/account' ) >= 0}
            title="Users"
            onChange={() => history.push( `/project/${project.id}/account` )}>
            Users
          </ToggleButton>

          <ToggleButton
            variant="navItem"
            value={path.indexOf( '/oidc' ) >= 0}
            title="OpenID"
            onChange={() => history.push( `/project/${project.id}/oidc` )}>
            OpenID
          </ToggleButton>

          <ToggleButton
            variant="navItem"
            value={path.indexOf( '/apiAccess' ) >= 0}
            title="API Access"
            onChange={() => history.push( `/project/${project.id}/apiAccess` )}>
            API Access Keys
          </ToggleButton>

          <ToggleButton
            variant="navItem"
            value={path.indexOf( '/clientId' ) >= 0}
            title="Client IDs"
            onChange={() => history.push( `/project/${project.id}/clientId` )}>
            Client IDs
          </ToggleButton>

          <Text variant="navTitle">
            <i className={classnames( 'fa fa-window-restore', style.icon )} />
            Application Controls
          </Text>
          {/* <ToggleButton
            variant="navItem"
            value={path.indexOf( '/molten' ) >= 0}
            title="Molten"
            onChange={() => history.push( `/project/${project.id}/molten` )}>
            Molten UI
          </ToggleButton> */}

          <ToggleButton
            variant="navItem"
            value={path.indexOf( '/scenario' ) >= 0}
            title="Scenarios"
            onChange={() => history.push( `/project/${project.id}/scenario` )}>
            Scenarios
          </ToggleButton>

          <ToggleButton
            variant="navItem"
            value={path.indexOf( '/template' ) >= 0}
            title="Templates"
            onChange={() => history.push( `/project/${project.id}/template` )}>
            Templates
          </ToggleButton>

          <Text variant="navTitle">
            <i className={classnames( 'fa fa-cog', style.icon )} />
            Project
          </Text>
          <ToggleButton
            variant="navItem"
            value={path.indexOf( '/settings' ) >= 0}
            title="Details"
            onChange={() => history.push( `/project/${project.id}/settings` )}>
            Settings
          </ToggleButton>

          <ToggleButton
            variant="navItem"
            value={path.indexOf( `/project/${project.id}/users` ) >= 0}
            title="Access"
            onChange={() => history.push( `/project/${project.id}/users` )}>
            Access
          </ToggleButton>

          <ToggleButton
            variant="navItem"
            value={path.indexOf( `/project/${project.id}/rule` ) >= 0}
            title="Rules Events"
            onChange={() => history.push( `/project/${project.id}/rule` )}>
            Rules
          </ToggleButton>

          <ToggleButton
            variant="navItem"
            value={path.indexOf( `/project/${project.id}/maintenanceEvent` ) >= 0}
            title="Maintenance Events"
            onChange={() => history.push( `/project/${project.id}/maintenanceEvent` )}>
            Maintenance Events
          </ToggleButton>

          <div className={style.sectionBreak} />

          <ToggleButton
            variant="navItemTop"
            title="Documentation"
            onChange={() => window.open( process.env.DOCS_URL, '_blank' )}>
            <i className={classnames( 'fa fa-book', style.icon )} />
            Documentation
          </ToggleButton>

          <ToggleButton
            variant="navItemTop"
            value={path.indexOf( '/map' ) >= 0}
            title="Map"
            onChange={() => history.push( `/project/${project.id}/geotile` )}>
            <i className={classnames( 'fa fa-map', style.icon )} />
            Map
          </ToggleButton>

        </Content.Header>

        <Content.Area variant="contentArea" >
          {content}
        </Content.Area>

      </Content>

    )
  }
}

export default connect(
  state => ( {
    project : state.project,
    scripts : state.scripts
  } )
)( ProjectSidebar )
